"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toInteger(val) {
    if (typeof val === 'number' && val > Number.MAX_SAFE_INTEGER) {
        return 0;
    }
    else if (typeof val === 'boolean' && val === true) {
        return 1;
    }
    else {
        return parseInt(`${val}`) || 0;
    }
}
exports.toInteger = toInteger;
//# sourceMappingURL=to-integer.js.map